import { render, staticRenderFns } from "./InstagramCommentReply.vue?vue&type=template&id=23b21bba"
import script from "./InstagramCommentReply.vue?vue&type=script&lang=js"
export * from "./InstagramCommentReply.vue?vue&type=script&lang=js"
import style0 from "./InstagramCommentReply.vue?vue&type=style&index=0&id=23b21bba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports